
export function isUpper (item) {
  return item.toUpperCase() === item
}

export function pascalToHuman (pascalText) {
  if ((pascalText || '').length === 0) return ''
  const res = []
  for (let i=0; i<pascalText.length; i++) {
    if (i > 0 && isUpper(pascalText[i])) {
      res.push(' ') // space between words
    }
    if (i === 0) {
      res.push(pascalText[i].toUpperCase())
    } else {
      res.push(pascalText[i])
    }
  }
  return res.join('')
}